<div [ngStyle]="{'width': 'width' ? width+'px' : '140px'}" [class]="getBackgroundClass()">
    <span>{{ content }}</span>
</div>



